import { createSelector } from '@reduxjs/toolkit';

import { GlobalState } from '@/redux/store';

const stateSelector = (state: GlobalState) => state;
const searchPromotedSlice = createSelector(stateSelector, (state) => state.searchPromoted);

export const getPromotedSearchResults = createSelector(searchPromotedSlice, (state) => state.itemIds || []);
export const getSEOSearchPageBreadcrumbs = createSelector(searchPromotedSlice, (state) => state.breadcrumbs || []);
